var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7.69531 21.4551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.4551,
    opacity: 0,
    width: 7.69531,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 3.68164C7.33398 5.40039 6.16211 6.8457 4.57031 7.23633L4.57031 16.2988C4.57031 19.1895 4.0625 20.752 3.66211 20.752C3.27148 20.752 2.75391 19.1797 2.75391 16.2988L2.75391 7.23633C1.16211 6.83594 0 5.40039 0 3.68164C0 1.66016 1.63086 0 3.66211 0C5.70312 0 7.33398 1.66016 7.33398 3.68164ZM1.35742 2.61719C1.35742 3.30078 1.94336 3.88672 2.61719 3.88672C3.30078 3.88672 3.86719 3.30078 3.86719 2.61719C3.86719 1.94336 3.30078 1.36719 2.61719 1.36719C1.94336 1.36719 1.35742 1.94336 1.35742 2.61719Z",
    fill: "#ffffff",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/mappin.614fdae56484dc85f32f8268fb22f532.svg";
export { ForwardRef as ReactComponent };